/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */

import Carousel from "react-bootstrap/Carousel";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import {
  getExerciseDetail,
  getProgram,
  getWeekSchedule,
  updateProgramDayStatus,
} from "../../../actions/user_program";
import { FadeLoader } from "react-spinners";
import { useNavigate, useParams } from "react-router-dom";
import Exercises from "./Exercises";
import BreadcrumbMenu from "../BreadcrumbMenu";
import { UPDATE_PROGRAM_STATUS_PURGE } from "../../../actions/types";
import { CommonPageData } from "../../../styles/common.style";
import { Link } from "react-router-dom";
import { RiLayoutGridFill, RiListUnordered } from "react-icons/ri";
import { REQUEST_STATUS } from "../../../utils/constants";
import { setActiveDayId } from "../../../actions/user_active_day";

const ProgramWeekSlider = ({
  weekScheduleRequestStatus,
  programId,
  getWeekSchedule,
  getProgram,
  weekSchedule,
  getExerciseDetail,
  exercises,
  updateProgramDayStatus,
  userProgramDayStatusUpdateSuccess,
  start,
  setStart,
  program,
  activeDayId,
  setActiveDayId,
}) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const dispatch = useDispatch();
  const [resume, setResume] = useState(false);
  const [view, setView] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [activeWeekIndex, setActiveWeekIndex] = useState(0);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    setView(event.target.checked);
  };

  const breadcrumbs = [
    { label: "Home", link: "/home" },
    { label: `${program?.name}`, link: "#", isActive: true },
  ];

  useEffect(() => {
    getProgram(id);
    getWeekSchedule(id);

    return () => {
      // Clear the active day ID when the component unmounts
      setActiveDayId(null);
    }
  }, []);

  useEffect(() => {
    let activeEx = exercises?.filter((item, index) => item.is_started == true);
    setResume(activeEx?.length > 0 ? true : false);
  }, [exercises]);

  useEffect(() => {
    if (activeDayId && weekSchedule) {
      let days = weekSchedule.map((week) => week.days).flat();

      setActiveDayId(activeDayId);

      let activeDayDetails = days.filter(
        (item, index) => item.id === activeDayId
      );

      localStorage.setItem(
        "activeDayName",
        `Day ${activeDayDetails[0]?.programDay?.day}`
      );

      getExerciseDetail(activeDayId);
    }
  }, [activeDayId]);

  // Note: This effect sets the first active day if no active day is found
  // in the week schedule. It checks if there is an active day and sets it,
  // otherwise it defaults to the first day of the first week.
  // This is useful for ensuring that there is always an active day selected
  // when the component mounts or when the week schedule changes.
  // It also updates the local storage with the active day ID and name.
  // This effect runs whenever the weekSchedule changes.
  // It ensures that the active day is set correctly based on the week schedule.
  useEffect(() => {
    if (weekSchedule) {
      let isActiveDayFound = false;

      weekSchedule.forEach((week) => {
        week.days.forEach((day) => {
          if (day.is_active === 1) {
            isActiveDayFound = true;
            setActiveDayId(day.id);
            setActiveWeekIndex(week.week - 1);
          }
        });
      });

      if (!isActiveDayFound) {
        // If no active day found, set the first day of the first week as active
        if (weekSchedule.length > 0 && weekSchedule[0].days.length > 0) {
          const firstDay = weekSchedule[0].days[0];
          setActiveDayId(firstDay.id);
          setActiveWeekIndex(0);
        }
      }
    }
  }, [weekSchedule]);

  const changeDayId = (id, program_id, day) => {
    setActiveDayId(id);

    let dt = {
      is_active: 1,
      program_id: program_id,
    };

    updateProgramDayStatus(dt, id);
  };

  if (weekScheduleRequestStatus === REQUEST_STATUS.FAILURE) {
    navigate("/welcome", { replace: true });
  } else if (weekScheduleRequestStatus === REQUEST_STATUS.REQUESTED) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12 center-loader">
            <FadeLoader color={"#FB1417"} height={10} />
          </div>
        </div>
      </div>
    );
  }

  if (userProgramDayStatusUpdateSuccess) {
    dispatch({ type: UPDATE_PROGRAM_STATUS_PURGE });
    getWeekSchedule(id);
  }

  const handleSelect = (selectedIndex) => {
    setActiveWeekIndex(selectedIndex);
  };

  return (
    <>
      <CommonPageData>
        <section className="assestmentgrid_001">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-12 col-md-12 p-0">
                <Carousel
                  className="box_week"
                  activeIndex={activeWeekIndex}
                  onSelect={handleSelect}
                  indicators={false}
                  nextLabel=""
                  prevLabel=""
                  interval={null}
                >
                  {weekSchedule?.map((week) => (
                    <Carousel.Item
                      style={{ textAlign: "center" }}
                      key={week.week}
                    >
                      <h6>Week {week.week}</h6>
                      <div className="box_date">
                        <ul className="date_week">
                          {week.days.length > 0 ? (
                            week.days.map((day) => (
                              <li key={day?.id}>
                                <p
                                  className={
                                    day?.is_active === 1 ||
                                    activeDayId === day?.id
                                      ? "active"
                                      : ""
                                  }
                                  data-toggle="modal"
                                  data-target="#statusCheckout1"
                                  style={{ cursor: "pointer" }}
                                >
                                  <span
                                    onClick={() =>
                                      changeDayId(
                                        day?.id,
                                        day?.program_id,
                                        day?.programDay?.day
                                      )
                                    }
                                  >
                                    Day {day?.programDay?.day}
                                  </span>
                                </p>
                              </li>
                            ))
                          ) : (
                            <li>
                              <p>No days available</p>
                            </li>
                          )}
                        </ul>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </section>
        <section className="welcome_002">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-8 col-md-8">
                <BreadcrumbMenu breadcrumbs={breadcrumbs} />
              </div>
              <div className="col-12 col-lg-4 col-md-12">
                <div className="pro text-center-mobile text-right">
                  <Link
                    to={`/weekly-progress/${activeDayId}`}
                    className="theme-btn-link d-inline-block mt-20"
                  >
                    Progress Report
                  </Link>

                  {resume && (
                    <>
                      <span>-</span>
                      <Link
                        to={`/assessment-timer`}
                        className="theme-btn-link d-inline-block mt-20"
                      >
                        Resume
                      </Link>
                    </>
                  )}
                </div>
                <div className="nav_week justify-content-end">
                  <Link to="#" className="daily">
                    <RiLayoutGridFill /> Grid View
                  </Link>
                  <div className="button-switch">
                    <input
                      type="checkbox"
                      id="addsetting"
                      className="switch sw_btn"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="addsetting" className="lbl-off"></label>
                  </div>
                  <Link to="#" className="weekly">
                    List View <RiListUnordered />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Exercises
          activeDayId={activeDayId}
          programId={id ? id : null}
          view={view}
          exercises={exercises}
          setStart={setStart}
          start={start}
        />
      </CommonPageData>
    </>
  );
};

ProgramWeekSlider.propTypes = {
  weekSchedule: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  weekScheduleRequestStatus:
    state.programReducer.weekScheduleRequestStatus || null,
  userProgramDayStatusUpdateSuccess:
    state.programReducer.userProgramDayStatusUpdateSuccess || null,
  programId: state.programReducer.programId,
  weekSchedule: state.programReducer.weekSchedule,
  exercises: state.programReducer.exercises,
  activeDayId: state.userActiveDayReducer.activeDayId,
});

export default connect(mapStateToProps, {
  getWeekSchedule,
  getProgram,
  getExerciseDetail,
  updateProgramDayStatus,
  setActiveDayId,
})(ProgramWeekSlider);
